"use client";

;
import './index.scss';
import { ProgramDetailCardProps } from '@/interfaces';
import TypoGraphy from '@/typography';
import { projectImages } from '../../../public/Assets/Images';
import MentorDetails from '../MentorDetails';
import { RouteStrings } from '@/utils/routestrings';
import { useParams } from 'next/navigation';
import { getSlugAndRouteName } from '@/utils/Functions';
import useViewType from '@/utils/Hooks/useViewType';
import eventTracker from '@/utils/eventTracker';
import Image from 'next/image';
import ThumbnailImage from '@/utils/Hooks/useThumbnailImage';
import { gumletLoader } from '@/utils/gumlet';
const ProgramDetailCard = ({
  title,
  courseId,
  desc,
  mentorDetails,
  chapters,
  rating,
  difficultyLevel,
  isPremium,
  industry,
  subIndustry,
  date,
  duration,
  premiumCardLink,
  subText,
  thumbnailText,
  bgColor
}: ProgramDetailCardProps) => {
  const handleCardClick = (isPremium: boolean) => {
    if (isPremium === true) {
      eventTracker.premiumCourseCardClicked({
        courseName: title,
        courseId: courseId,
        mentorName: mentorDetails?.name,
        applicationLink: premiumCardLink
      });
    } else if (!isPremium) {
      eventTracker.freeCourseCardClicked({
        courseName: title,
        courseId: courseId,
        courseDifficulty: difficultyLevel,
        mentorName: mentorDetails.name
      });
    }
  };
  const params = useParams();
  const {
    isIndustry,
    isSubIndustry
  } = getSlugAndRouteName(params?.route?.toString() || '');
  const isMobile = useViewType();
  const getCardItems = () => {
    const getDifficultyImage = (level: string): string => {
      if (level.toLowerCase().includes("begin")) return projectImages.chartBeginner;
      if (level.toLowerCase().includes("inter")) return projectImages.chartIntermediate;
      return projectImages.chartAdvanced;
    };
    if (!isPremium && rating && chapters && difficultyLevel) {
      return <>
        <div className="item_wrapper">
          <Image loader={gumletLoader} width={14} height={14} src={projectImages.ratingStar} alt="rating" loading='lazy' />
          <TypoGraphy text={rating?.toString()} variant='Desktop/Caption/R | 12 |120' />
        </div>
        <div className="item_wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
            <path d="M7.92353 12.9724C8.09524 13.0123 8.11097 13.2372 7.94372 13.293L6.95622 13.618C4.47497 14.418 3.16872 13.7492 2.36247 11.268L1.56247 8.79922C0.762469 6.31797 1.42497 5.00547 3.90622 4.20547C4.28787 4.07908 4.66787 4.46496 4.57154 4.85528C4.56641 4.87605 4.56131 4.89694 4.55622 4.91797L3.94372 7.53672C3.25622 10.4805 4.26247 12.1055 7.20622 12.8055L7.92353 12.9724Z" fill="#818490" />
            <path d="M10.7314 2.50534L9.68761 2.26159C7.60011 1.76784 6.35636 2.17409 5.62511 3.68659C5.43761 4.06784 5.28761 4.53034 5.16261 5.06159L4.55011 7.68034C3.93761 10.2928 4.74386 11.5803 7.35011 12.1991L8.40011 12.4491C8.76261 12.5366 9.10011 12.5928 9.41261 12.6178C11.3626 12.8053 12.4001 11.8928 12.9251 9.63659L13.5376 7.02409C14.1501 4.41159 13.3501 3.11784 10.7314 2.50534ZM9.55636 8.83034C9.50011 9.04284 9.31261 9.18034 9.10011 9.18034C9.06261 9.18034 9.02511 9.17409 8.98136 9.16784L7.16261 8.70534C6.91261 8.64284 6.76261 8.38659 6.82511 8.13659C6.88761 7.88659 7.14386 7.73659 7.39386 7.79909L9.21261 8.26159C9.46886 8.32409 9.61886 8.58034 9.55636 8.83034ZM11.3876 6.71784C11.3314 6.93034 11.1439 7.06784 10.9314 7.06784C10.8939 7.06784 10.8564 7.06159 10.8126 7.05534L7.78136 6.28659C7.53136 6.22409 7.38136 5.96784 7.44386 5.71784C7.50636 5.46784 7.76261 5.31784 8.01261 5.38034L11.0439 6.14909C11.3001 6.20534 11.4501 6.46159 11.3876 6.71784Z" fill="#818490" />
          </svg>
          <TypoGraphy text={`${chapters} chapters`} variant='Desktop/Caption/R | 12 |120' />
        </div>
        <div className="item_wrapper">
          <Image loader={gumletLoader} width={15} height={16} src={getDifficultyImage(difficultyLevel)} alt="chapters" loading='lazy' />
          <TypoGraphy text={difficultyLevel} variant='Desktop/Caption/R | 12 |120' />
        </div>
      </>;
    }
    if (isPremium && (date || subText || duration)) {
      return <>
        {date && <div className="item_wrapper">
          <Image loader={gumletLoader} width={15} height={16} src={projectImages.calendar} alt="calender" loading='lazy' />
          <TypoGraphy text={date} variant='Desktop/Caption/R | 12 |120' />
        </div>}
        {duration && <div className="item_wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
            <path d="M7.5 1.75C4.05625 1.75 1.25 4.55625 1.25 8C1.25 11.4438 4.05625 14.25 7.5 14.25C10.9438 14.25 13.75 11.4438 13.75 8C13.75 4.55625 10.9438 1.75 7.5 1.75ZM10.2188 10.2312C10.1313 10.3812 9.975 10.4625 9.8125 10.4625C9.73125 10.4625 9.65 10.4438 9.575 10.3938L7.6375 9.2375C7.15625 8.95 6.8 8.31875 6.8 7.7625V5.2C6.8 4.94375 7.0125 4.73125 7.26875 4.73125C7.525 4.73125 7.7375 4.94375 7.7375 5.2V7.7625C7.7375 7.9875 7.925 8.31875 8.11875 8.43125L10.0562 9.5875C10.2812 9.71875 10.3562 10.0062 10.2188 10.2312Z" fill="#818490" />
          </svg>
          <TypoGraphy text={`${duration} weeks`} variant='Desktop/Caption/R | 12 |120' />
        </div>}
        {subText && <div className="item_wrapper">
          <Image loader={gumletLoader} width={15} height={16} src={projectImages.userSquareDark} alt="session" loading='lazy' />
          <TypoGraphy text={subText} variant='Desktop/Caption/R | 12 |120' />
        </div>}
      </>;
    }
    return <></>;
  };
  const titleText = title?.length > 55 ? title.substring(0, 55) + '...' : title;
  const descText = desc?.length > 55 ? desc.substring(0, 55) + '...' : desc;
  return <div className="program_detail_card_wrapper" onClick={e => {
    handleCardClick(isPremium);
  }} suppressHydrationWarning={true} data-sentry-component="ProgramDetailCard" data-sentry-source-file="index.tsx">
      <a className={isPremium ? "premium_card" : "program_detail_card"} target='_self' href={isPremium ? premiumCardLink : RouteStrings.DYNAMICROUTE(industry, 'COURSEDETAIL', courseId)} title={title}>
        <div className="image_wrapper">
          <ThumbnailImage itemId={courseId} data-sentry-element="ThumbnailImage" data-sentry-source-file="index.tsx" />
          <div className='thumbnail_text'>
                  <TypoGraphy color={isPremium ? 'white' : 'black'} text={thumbnailText || ''} variant={thumbnailText && thumbnailText?.length > 60 ? 'Desktop/Thumbnail | 16 | 140' : 'Mobile/Heading 1/S | 20 | 120'} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx"></TypoGraphy>
                </div>
          {isPremium && <div className="premium_tag_wrapper">
            <div className="premium_div">
              <TypoGraphy text='Premium' variant={isMobile ? 'LP/Pre-header/Pre-header' : 'Desktop/Caption'} />
            </div>
          </div>}
        </div>
        <div className="middle_content_wrapper">
          <div className="text_content_wrapper">
            <div className="card_heading">
              <TypoGraphy text={titleText} variant={'Mobile/Body 1'} tagName={isIndustry || isSubIndustry ? 'h2' : 'h4'} styles={{
              fontSize: !isMobile ? "18px" : "16px",
              lineHeight: !isMobile ? "135%" : ""
            }} data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
            </div>
            <div className="card_sub_heading">
              <TypoGraphy text={descText} variant='Mobile/Body 2' styles={{
              textAlign: 'left'
            }} color='#030A21' data-sentry-element="TypoGraphy" data-sentry-source-file="index.tsx" />
            </div>
          </div>
          <div className="card_items_wrapper">
            {getCardItems()}
          </div>
        </div>
        <div className="bottom_content_wrapper">
          <MentorDetails mentorImageUrl={mentorDetails?.mentorImageUrl} name={mentorDetails?.name} designation={mentorDetails?.designation} companyName={mentorDetails?.companyName} data-sentry-element="MentorDetails" data-sentry-source-file="index.tsx" />
        </div>
      </a>
    </div>;
};
export default ProgramDetailCard;